import { Layout } from '../components/Layout';
import { GoogleAuthLoginForm } from '../components/GoogleAuthLoginForm';

export const GoogleAuthLogin = () => {
  return (
    <Layout title="Google Authenticator Code Required">
      <GoogleAuthLoginForm />
    </Layout>
  );
};
